import FacilitiesFilters from './FacilitiesFilters'

export default FacilitiesFilters
